function initSantarcCatalogFilter(root) {
  const chips = Array.from(root.querySelectorAll('[data-santarc-filter]'));
  const cards = Array.from(root.querySelectorAll('[data-santarc-card]'));

  chips.forEach((chip) => {
    chip.addEventListener('click', () => {
      chips.forEach((c) => c.classList.remove('is-active'));
      chip.classList.add('is-active');
      const value = chip.dataset.santarcFilter;

      cards.forEach((card) => {
        const matches = value === 'todos' || card.dataset.santarcBrand === value;
        card.style.display = matches ? '' : 'none';
      });
    });
  });
}

document.querySelectorAll('[data-santarc-catalog]').forEach(initSantarcCatalogFilter);

document.addEventListener('shopify:section:load', (event) => {
  const root = event.target.querySelector('[data-santarc-catalog]');
  if (root) initSantarcCatalogFilter(root);
});
